module.exports.default = {
    "ORDER": "Auftrag",
    "SCHEDULE.YOU_ARE_ALL_SET": "Sie sind bereit!",
    "SCHEDULE.YOUR_DELIVERY_IS_SCHEDULED_FOR": "Ihre Lieferung ist geplant für",
    "SCHEDULE.CUSTOMER_#_MESSAGE": "Hallo #, bitte planen Sie Ihre Lieferung",
    "SCHEDULE.SCHEDULE_NOW": "Verschieben",
    "SCHEDULE.DELIVERY_STATUS_UPDATES": "Lieferung & Status-Updates",
    "SCHEDULE.EMAIL_UPDATES": "E-Mail-Aktualisierungen",
    "SCHEDULE.SMS_UPDATES": "SMS-Aktualisierung",
    "SCHEDULE.DISABLE_UPDATES": "Ich möchte keine Updates erhalten.",
    "SCHEDULE.STATUS_UPDATE_IN_THE_FOLLOWING": "Ich möchte den aktuellen Status meiner Lieferung in den folgenden Kanälen erhalten:",
    "OOPS": "Oops!",
    "SOMETHING_WENT_WRONG": "",
    "REFRESH": "Aktualisieren",
    "PAGE_NOT_FOUND": "Seite nicht gefunden",
    "COULD_NOT_FIND_PAGE": "Wir konnten die von Ihnen gesuchte Seite nicht finden.",
    "TRACKING.MESSAGE_DRIVER_FAILED": "Kann keine leere Nachricht senden",
    "TRACKING.MESSAGE_DRIVER_PLACEHOLDER": "Gern können Sie dem Fahrer-Team eine Nachricht senden",
    "TRACKING.SEND": "Via Nachrichtendienst versenden",
    "TRACKING.ARRIVING_AT": "Ankommend um",
    "TRACKING.ETA": "ETA",
    "TRACKING.MIN": "min",
    "TRACKING.MAP": "Verkehr",
    "TRACKING.SATELLITE": "Satellit",
    "TRACKING.TERRAIN": "Gelände",
    "TRACKING.DRIVER_ARRIVED_MESSAGE": "Hey, ich bin angekommen!",
    "TRACKING.DRIVER_ARRIVED_AT_MESSAGE": "ist angekommen",
    "COMPLETED": "Du hast aktuell keine aktiven Lieferungen",
    "RATING.SKIP": "Nicht jetzt",
    "RATING.WHAT_WENT_WELL": "Was ist gut gelaufen?",
    "RATING.WHAT_WENT_WRONG": "Was ist schief gelaufen?",
    "RATING.THANK_YOU": "",
    "RATING.FOR_USING_OUR_SERVICE": "Danke, dass Sie unseren Service genutzt haben!",
    "RATING.HOW_WAS_YOUR_DELIVERY": "Wie waren Ihre Erfahrungen bei der Lieferung?",
    "RATING.WHAT_WAS_YOUR_EXPERIENCE": "Bitte helfen Sie uns, uns zu verbessern, in dem Sie Ihre Erfahrung mit uns bewerten",
    "SCHEDULE.RATE_US": "Bewerten Sie uns!",
    "TERM_OF_USE": "Nutzungsbedingungen",
    "PRIVACY_POLICY": "Datenschutzrichtlinie",
    "SHARING_MY_LOCATION": "Finde mich",
    "SHARING_LOADING": "Lädt",
    "REQUIRED_FIELD_MESSAGE": "Alle Felder sind verpflichtend",
    "CONTACT_NAME": "Kontaktname",
    "PHONE_NUMBER": "Telefonnummer",
    "EMAIL_ADDRESS": "E-Mail Adresse",
    "SEND": "senden\n",
    "FORWARD.THIS_ORDER": "Leite die Lieferung weiter",
    "FORWARD.TO_CONTACT": "Leite es an einen Kontakt in",
    "FORWARD.ARE_YOU_SURE_MESSAGE": "Bist du sicher, dass du diese Bestellung weiterleiten möchtest?",
    "FORWARDED.HAS_DELIVERY_FORWARDED_DELIVERY": "hat eine Lieferung an Sie weitergeleitet",
    "FORWARDED.ARE_YOU_SURE_MESSAGE": "Bist du sicher, dass du diese Lieferung ablehnen möchtest?",
    "ACCEPT": "Annehmen",
    "REJECT": "Zurückweisen",
    "PICKUP.SET_PICKUP_TIME": "Ich bin auf dem Weg",
    "PICKUP.IVE_ARRIVED": "",
    "PICKUP.PICKUP_ETA_SET_FAILED": "",
    "PICKUP.ETA_SET_FAILED_DESCRIPTION": "",
    "PICKUP.MIN": "",
    "PICKUP.SHOW_THIS_NUMBER": "",
    "PICKUP.IM_OUTSIDE": "",
    "PICKUP.LET_THEM_KNOW_YOUR_OUTSIDE?": "",
    "PICKUP.I_WILL_ARRIVE_AT": "",
    "PICKUP.PICKUP_ETA_SUCCESSFULLY_SET": "",
    "PICKUP.IN": "",
    "PICKUP.TO": "",
    "PICKUP.COLLECT": "",
    "PICKUP.SELECT_METHOD_OF_TRANSPORT": "",
    "PICKUP.CONFIRM_METHOD_OF_TRANSPORT": "",
    "PICKUP.CANCEL": "",
    "PICKUP.CONFIRM_TIME": "",
    "TRACKING.DRIVER_ROUTE_ONE_STOP_MESSAGE": "Der Fahrer ist derzeit einen Stopp von Ihnen entfernt\n",
    "TRACKING.DRIVER_ROUTE_STOPS_MESSAGE_PART2": "Stopps von Ihnen entfernt",
    "TRACKING.DRIVER_ROUTE_STOPS_MESSAGE_PART1": "Der Fahrer ist derzeit",
    "PICKUP.OK": "",
    "PICKUP.NEXT": "",
    "PICKUP.SKIP": "",
    "CAR_ARRIVED.TITLE": "",
    "CAR_ARRIVED.PARKING_SPOT": "",
    "CAR_ARRIVED.LICENSE_PLATE": "",
    "CAR_ARRIVED.VEHICLE_MODEL": "",
    "CAR_ARRIVED.VEHICLE_COLOR": "",
    "CAR_ARRIVED.REMEMBER": "",
    "CAR_ARRIVED.PARKING_SPOT_EXAMPLE": "",
    "CAR_ARRIVED.LICENSE_PLATE_EXAMPLE": "",
    "CAR_ARRIVED.VEHICLE_MODEL_EXAMPLE": "",
    "CAR_ARRIVED.VEHICLE_COLOR_EXAMPLE": "",
    "REDIRECT_PICKUP.TO": "",
    "REDIRECT_PICKUP.CONFIRM_TITLE": "",
    "REDIRECT_PICKUP.SUCCESS_TITLE": "",
    "REDIRECT_PICKUP.FAILED_TITLE": "",
    "REDIRECT_PICKUP.FAILED_DESCRIPTION": "",
    "REDIRECT_PICKUP.OK": "",
    "REDIRECT_PICKUP.KM": "",
    "REDIRECT_PICKUP.SELECT_PICKUP_LOCATION": "",
    "REDIRECT_PICKUP.SET_AS_PICKUP_LOCATION": "",
    "REDIRECT_PICKUP.PICKUP_OPTIONS": "",
    "SOON": "bald",
    "TRACKING.WANT_TO_CALL_YOUR_DRIVER": "",
    "GLOBAL.CALL": "",
    "GLOBAL.CANCEL": "",
    "﻿PICKUP.SET_PICKUP_TIME": "",
    "RATING.PROOF_OF_DELIVERY_MESSAGE": "",
    "SCHEDULED.THANKS_FOR_USING": "",
    "SCHEDULED.SHIPMENT_IN_TRANSIT": "",
    "SCHEDULED.YOUR_DELIVERY_IS_SCHEDULED_FOR": "",
    "Submit": "",
    "RATING.SELECT_STARS_BEFORE_SUBMIT": "Um bewerten zu können, wählen Sie zuerst die Sterne",
    "PICKUP.SHOW_ID": "",
    "TRACKING.ESTIMATED_TIME_ARRIVAL": "",
    "OPEN_MENU": "",
    "CLOSE_MENU": "",
    "MAP_AUTO_CENTER": "",
    "MAP_SETTINGS": "",
    "ZOOM_OUT": "",
    "ZOOM_IN": "",
    "TRACKING.CALL_DRIVER": "",
    "TRACKING.MESSAGE_DRIVER": "",
    "PICKUP.SELECT_TIME_TO_CONFIRM": "",
    "PICKUP.SET_OR_ARRIVE_DESCRIPTION": "",
    "SCHEDULE.TIME_ZONE_TEXT": "",
    "TRACKING.THANKS_MESSAGE_SUBTITLE": "",
    "TRACKING.THANKS_MESSAGE_TEXT": "",
    "TRACKING.THANKS_MESSAGE_TITLE": "",
    "TRACKING.CLICK_COLLECT_MESSAGE_TEXT": "",
    "CANCEL_ORDER": "",
    "CANCELLATION_VALIDATION_TITLE": "",
    "CANCELLATION_VALIDATION_BACK": "",
    "CANCELLATION_VALIDATION_YES": "",
    "CANCEL_SUCCESS": "",
    "CANCEL_PAST_ALLOWED": "",
    "CANCEL_ERROR": "",
    "RATING.FREE_TEXT_COMMENT": "Erzählen Sie uns mehr",
    "RATING.ORDER_DELIVERED_GREEN": "Wir haben Ihre Bestellung mit einem umweltfreundlichen Fahrzeug geliefert",
    "CX_ORDER_STATUS.CONFIRMED": "Bestellung bestätigt. Sie wird bearbeitet.",
    "CX_ORDER_STATUS.RECEIVED": "Bestellung erhalten. Wir werden uns in Kürze in Verbindung setzen.",
    "CX_ORDER_STATUS.FINDING_DRIVER": "Wir haben einen Fahrer für Ihre Bestellung zugeordnet",
    "CX_ORDER_STATUS.DRIVER_FOUND": "Wir haben den Fahrer für Ihre Bestellung gefunden.",
    "CX_ORDER_STATUS.PICKING_UP": "Wir nehmen Ihre Bestellung gerade auf.",
    "CX_ORDER_STATUS.WAY_TO_PICKUP": "Wir sind auf dem Weg, Ihre Bestellung abzuholen.",
    "CX_ORDER_STATUS.ON_PREVIOUS_DELIVERY": "Wir beenden eine vorherige Lieferung bevor Ihrer Bestellung.",
    "CX_ORDER_STATUS.WAY_TO_DROPOFF": "Ihre Bestellung ist jetzt auf dem Weg zu Ihnen!",
    "CX_ORDER_STATUS.ARRIVED": "Ihre Bestellung ist eingegangen!",
    "TRACKING.DELIVERY_STATUS_TITLE": "Lieferstatus",
    "CONFIGURATION.TAGS.SHOW_DELIVERY_STATUS": "Lieferstatus für Kunden anzeigen",
    "CONFIRM": "Bestätigen",
    "FLOW_OPTIONS.TITLE": "Wie möchten Sie Ihre Bestellung einsammeln?",
    "FLOW_OPTIONS.CURBSIDE_BUTTON_LABEL": "Ausgeliefert zu Ihrem Auto an einem bestimmten Ort",
    "FLOW_OPTIONS.CURBSIDE_BUTTON_TEXT": "Bordsteinseite",
    "FLOW_OPTIONS.CLICK_AND_COLLECT_LABEL": "Abholung im Laden oder an einem festgelegten Ort",
    "FLOW_OPTIONS.CLICK_AND_COLLECT_TEXT": "Klicken & Einsammeln",
    "RATING_STAR_ALT": "",
    "RATING_STAR_ALT_ONE": "Wählen Sie, um die Bewertung von",
    "RATING_STAR_ALT_TWO": "Sternen zu verlassen",
    "TRACKING.ARRIVING_IN_ARIA_LABEL": "Die geschätzte Ankunftszeit beträgt",
    "TRACKING.MAP_CONTAINER_ARIA_LABEL": "Karte, um die Reihenfolge zu verfolgen",
    "SCHEDULE.EXTERNAL_ID_INFO": "Auftrag ID: {{externalId}}",
    "SCHEDULE.TASK_NOTE_LABEL": "",
    "SCHEDULE.CANCEL_NOTE_INPUT": "Löschen",
    "DELIVERY_WAS_CANCELLED": "Lieferung storniert"
};
	